import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './StepModalHeader.module.scss'

const variantToClass = {
  primary: styles.variantPrimary,
  engage: styles.variantEngage,
}

const propTypes = {
  /**
   * Steps array: each step should contain a label and a key
   */
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      key: PropTypes.string,
    }),
  ).isRequired,
  /**
   * Index of the active step.
   * Steps that come before the stepIndex are set as completed
   */
  stepIndex: PropTypes.number.isRequired,
  /**
   * Color variant of the component
   */
  variant: PropTypes.oneOf(['primary', 'engage']),
}

function StepModalHeader(props) {
  const { steps, stepIndex, variant = 'primary' } = props ?? {}

  return (
    <div className={clsx('d-flex', variantToClass[variant])}>
      {steps
        .filter((step) => step.label !== null)
        .map((step, index) => (
          <Step key={step.key} label={step.label} active={index === stepIndex} completed={index < stepIndex} />
        ))}
    </div>
  )
}

StepModalHeader.propTypes = propTypes

export default StepModalHeader

// SUPPORT COMPONENTS
/* eslint-disable react/prop-types */
function Step(props) {
  const { label, active, completed } = props
  return (
    <div className={clsx(styles.step, active && styles.active, completed && styles.completed)}>
      <span className={styles.label}>{label}</span>
      <div className={styles.bar} />
    </div>
  )
}
